import React from 'react';
import { ArrowLeftIcon, FileTextIcon } from 'lucide-react';
export function TermsOfService() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-[#D4A24C] selection:text-white" data-id="element-398">
      {/* Simple Header */}
      <header className="bg-white border-b border-slate-200 py-6 sticky top-0 z-50" data-id="element-399">
        <div className="max-w-4xl mx-auto px-6 flex justify-between items-center" data-id="element-400">
          <a href="/" className="text-2xl font-bold text-[#0F172A] tracking-tight" data-id="element-401">
            Nationwide<span className="text-[#D4A24C]" data-id="element-402">Home Buyers</span>
          </a>
          <a href="/" className="inline-flex items-center text-[#0F172A] font-medium hover:text-[#D4A24C] transition-colors text-sm" data-id="element-403">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-404" />
            Back to Home
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 md:py-24 px-6" data-id="element-405">
        <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100" data-id="element-406">
          <div className="w-10 h-10 bg-[#D4A24C]/10 rounded-lg flex items-center justify-center mb-6" data-id="element-407">
            <FileTextIcon className="w-5 h-5 text-[#D4A24C]" data-id="element-408" />
          </div>

          <h1 className="text-3xl md:text-4xl font-extrabold text-[#0F172A] mb-4" data-id="element-409">
            Terms of Service
          </h1>
          <p className="text-slate-500 mb-12" data-id="element-410">Last Updated: October 15, 2023</p>

          <div className="space-y-8 text-slate-600 leading-relaxed" data-id="element-411">
            <section data-id="element-412">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-413">
                1. Acceptance of Terms
              </h2>
              <p data-id="element-414">
                By accessing and using NationwideHomeBuyers.com ("the Website"),
                you agree to be bound by these Terms of Service. If you do not
                agree to these terms, please do not use our Website or services.
              </p>
            </section>

            <section data-id="element-415">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-416">
                2. Description of Service
              </h2>
              <p data-id="element-417">
                NationwideHomeBuyers.com provides a platform for homeowners to
                request cash offers for their properties. We are a nationwide
                real estate investment company operating in all 50 states. We
                are not acting as your real estate agent or broker in any
                transaction.
              </p>
            </section>

            <section data-id="element-418">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-419">
                3. User Information and Accuracy
              </h2>
              <p data-id="element-420">
                When submitting information about your property, you agree to
                provide accurate, current, and complete information. You must be
                the legal owner of the property or have the legal authority to
                sell the property on behalf of the owner.
              </p>
            </section>

            <section data-id="element-421">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-422">
                4. No Obligation Offers
              </h2>
              <p className="mb-4" data-id="element-423">
                Cash offers presented by NationwideHomeBuyers.com are:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-424">
                <li data-id="element-425">
                  Not legally binding until a formal purchase agreement is
                  signed by both parties.
                </li>
                <li data-id="element-426">
                  Based on the information provided and our independent market
                  analysis.
                </li>
                <li data-id="element-427">
                  Subject to verification of property condition and clear title.
                </li>
                <li data-id="element-428">Provided at no cost and with no obligation to accept.</li>
              </ul>
            </section>

            <section data-id="element-429">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-430">
                5. Fees and Costs
              </h2>
              <p data-id="element-431">
                NationwideHomeBuyers.com does not charge sellers any fees,
                commissions, or hidden costs to make an offer. If a purchase
                agreement is executed, we typically cover standard closing costs
                as outlined in the specific agreement.
              </p>
            </section>

            <section data-id="element-432">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-433">
                6. Limitation of Liability
              </h2>
              <p data-id="element-434">
                NationwideHomeBuyers.com and its affiliates shall not be liable
                for any direct, indirect, incidental, special, or consequential
                damages resulting from the use or inability to use our services
                or Website.
              </p>
            </section>

            <section data-id="element-435">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-436">
                7. Intellectual Property
              </h2>
              <p data-id="element-437">
                All content on this Website, including text, graphics, logos,
                and design elements, is the property of NationwideHomeBuyers.com
                and is protected by copyright and intellectual property laws.
              </p>
            </section>

            <section data-id="element-438">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-439">
                8. Governing Law
              </h2>
              <p data-id="element-440">
                These Terms of Service shall be governed by and construed in
                accordance with the laws of the United States. Any disputes
                arising under these terms shall be subject to the exclusive
                jurisdiction of the appropriate jurisdiction.
              </p>
            </section>

            <section data-id="element-441">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-442">
                9. Modifications to Terms
              </h2>
              <p data-id="element-443">
                We reserve the right to modify these Terms of Service at any
                time. Changes will be effective immediately upon posting to the
                Website. Your continued use of the Website constitutes
                acceptance of the modified terms.
              </p>
            </section>

            <section data-id="element-444">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-445">
                10. Contact Information
              </h2>
              <p className="mb-4" data-id="element-446">
                If you have any questions about these Terms of Service, please
                contact us at:
              </p>
              <address className="not-italic text-slate-600" data-id="element-447">
                <p data-id="element-448">NationwideHomeBuyers.com</p>
                <p data-id="element-449">7901 4th St N ste 300</p>
                <p data-id="element-450">St Petersburg, FL 33702</p>
                <p className="mt-2" data-id="element-451">
                  Email:{' '}
                  <a href="mailto:info@nationwidehomebuyers.com" className="text-[#D4A24C] hover:underline" data-id="element-452">
                    info@nationwidehomebuyers.com
                  </a>
                </p>
                <p data-id="element-453">
                  Phone:{' '}
                  <a href="tel:+18556052101" className="text-[#D4A24C] hover:underline" data-id="element-454">
                    1-855-605-2101
                  </a>
                </p>
              </address>
            </section>
          </div>
        </div>
      </main>
    </div>;
}